import type { FunctionComponent } from 'react';
import { LocationPageTitle } from '../../../components/LocationPageTitle/LocationPageTitle';
import { useStatePageQuery } from '../../graphql/useStatePageQuery';

export const StatePageTitleWithData: FunctionComponent = () => {
  const titleParts = useStatePageQuery()?.data?.statePageBySlug?.title?.parts;
  if (!titleParts) return null;

  const [overline, title, subtitle] = titleParts;
  if (!overline || !title) return null;

  return <LocationPageTitle overline={overline} title={title} subtitle={subtitle} />;
};
